import "./tarifsMap.css";

function TarifsMap({ cost = "20€", postalCodes = [] }) {
  const postalCodeList = arrayToList({ postalCodes });
  return (
    <div className="map-List-container">
      <div className="map-List-border"></div>
      <div style={{ width: "100%" }}>
        <div className="map-List-title">{cost}</div>
        <div className="map-List-scroll">
          <div className="map-List">{postalCodeList}</div>
        </div>
      </div>
    </div>
  );
}

export default TarifsMap;

function arrayToList({ postalCodes }) {
  return (
    <>
      {postalCodes.map((code, index) => (
        <p>{code}</p>
      ))}
    </>
  );
}
